export interface StoredRateLimitState {
  remaining: number;
  limit: number;
  /** Unix timestamp (seconds) when the current rate-limit window expires. */
  reset: number;
}

const KEY_REMAINING = "rl_remaining";
const KEY_LIMIT = "rl_limit";
const KEY_RESET = "rl_reset";

export function storeRateLimitState(remaining: number, limit: number, reset: number): void {
  try {
    localStorage.setItem(KEY_REMAINING, String(remaining));
    localStorage.setItem(KEY_LIMIT, String(limit));
    localStorage.setItem(KEY_RESET, String(reset));
  } catch {
    // localStorage unavailable (private browsing, storage full, etc.) — fail silently
  }
}

/** Returns null when no state is stored or the window has already expired. */
export function readRateLimitState(): StoredRateLimitState | null {
  try {
    const remaining = localStorage.getItem(KEY_REMAINING);
    const limit = localStorage.getItem(KEY_LIMIT);
    const reset = localStorage.getItem(KEY_RESET);
    if (remaining === null || limit === null || reset === null) return null;
    const resetSec = Number(reset);
    if (Math.floor(Date.now() / 1000) >= resetSec) {
      clearRateLimitState();
      return null;
    }
    return { remaining: Number(remaining), limit: Number(limit), reset: resetSec };
  } catch {
    return null;
  }
}

export function clearRateLimitState(): void {
  try {
    localStorage.removeItem(KEY_REMAINING);
    localStorage.removeItem(KEY_LIMIT);
    localStorage.removeItem(KEY_RESET);
  } catch {
    // ignore
  }
}
